import { render, staticRenderFns } from "./ProductTileLabel.vue?vue&type=template&id=34d3f0f6&scoped=true&"
import script from "./ProductTileLabel.vue?vue&type=script&lang=js&"
export * from "./ProductTileLabel.vue?vue&type=script&lang=js&"
import style0 from "./ProductTileLabel.vue?vue&type=style&index=0&id=34d3f0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d3f0f6",
  null
  
)

export default component.exports